import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doPost } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";


export const getUserFolderDetails = createAsyncThunk(
    "userWiseFolderList",
    async (arg, { rejectWithValue }) => {
        try {
            const response = await doPost(urls?.userWiseFolderList, arg);
            return response;
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)

export const getUserFolderDetailsSlice = createSlice({
    name: "userWiseFolderList",
    initialState: {
        isLoading: false,
        error: null,
        success: false,
        data: false,
    },
    reducers: {
        userWiseFolderListReset: () => {
            return {
                isLoading: false,
                error: null,
                success: false,
                data: false,
            }
        }
    },
    extraReducers: {
        [getUserFolderDetails.fulfilled]: (state, { payload }) => {
              state.isLoading = false;
              state.error = null;
              state.data = payload;
              state.success = true;
            },
            [getUserFolderDetails.pending]: (state) => {
              state.isLoading = true;
              state.success = false;
              state.data = false;
            },
            [getUserFolderDetails.rejected]: (state,  {payload} ) => {
              state.isLoading = false;
              state.error = payload;
              state.data = false;
            },
    }
})

export const { userWiseFolderListReset } = getUserFolderDetailsSlice.actions;